import { useQuery } from 'react-query';
import { fetchUserPromotions } from '../fetchers/users';

export function useUserPromotions(userId) {
  const { data, isLoading, error } = useQuery(
    ['user-promotions', userId],
    () => fetchUserPromotions(userId),
    {
      enabled: !!userId,
    }
  );

  return {
    promotions: data?.promotions || [],
    isLoading,
    error,
  };
}
